import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {MvvmValidation, MvvmValidationResult} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";
import usePasswordRules from "./passwordRules";

export default function usePasswordRequiredPolicy(validateRequirements: boolean): MvvmValidation<string> {
	const rules = usePasswordRules();

	return useMemo<MvvmValidation<string>>(() => {
		const result: MvvmValidation<string> = {
			required: translation(PermitTranslations.validation__password__required)
		}

		if (!validateRequirements) {
			return result;
		}

		result.validate = function (password: string | undefined): MvvmValidationResult | undefined {
			const value = isNullOrEmpty(password) ? "" : password!;
			for (const rule of rules) {
				if (!rule.test(value)) {
					return {error: rule.error, type: rule.type};
				}
			}
			return undefined;
		}

		return result;
	}, [validateRequirements, rules]);
}
